import { Grid, Typography } from "@material-ui/core";
import styled, { keyframes } from "styled-components";
import { css } from "styled-components";
import Chip from "../../../../components/basics/Chip";

const green = (theme) => theme.theme.palette.green;
const opensans = (theme) => theme.theme.fonts.opensans;

const check = keyframes`
    from {
      transform: rotate(270deg) scale(1.10);
      filter: drop-shadow(3px 3px 3px #00000030);
    }
    
    to {
      transform: rotate(0deg) scale(1);
      filter: drop-shadow(none);
    }
    `;

export const ContractNumber = styled(Typography)`
  font-weight: bold !important;

  span {
    font-weight: normal !important;
  }
`;

export const CustomContainer = styled.div`
  min-height: 300px !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  overflow: hidden !important;
`;

export const StyledChip = styled(Chip)`
  width: 100%;
  font-size: 18px !important;
  margin-right: 0px;
  margin-left: 0px;
`;

export const CustomGrid = styled(Grid)`
  ${(props) =>
    props.flex === "1"
      ? css`
          flex: 1;
        `
      : css`
          display: flex;
          justify-content: center;
          flex-direction: column;
        `}
`;

export const FinishContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  pointer-events: none;
  user-select: none;
`;

export const FinishIcon = styled.div`
  color: ${green};
  margin-bottom: 16px;
  animation: ${check} 0.6s 0.5s forwards;

  .MuiSvgIcon-root {
    width: 5em;
    height: 5em;
  }
`;

export const FinishText = styled.p`
  font-family: ${opensans};
  margin: 0;

  margin-bottom: ${(props) => !props.subtitle && "8px"};
  font-size: ${(props) => (props.subtitle ? "24px" : "36px")};
  font-weight: ${(props) => !props.subtitle && "600"};
`;
